module.exports = __webpack_public_path__ + "mainassets/img/gps.6c682c14.svg";